import React from "react"
import "../../App.less"
import "../../styles/Benefits/Background.less"

const Background = ({ personaType = "Wealth", ...props}) => {

  return (
    <>
      <div className="GuaranteedIncome_Background">{props.children}</div>
    </>
  )
}

export default Background
